import React from 'react';
import {
	Card, Grid, Row, Col, Button, Typography, Badge,
} from '@sm/wds-react';

import PropTypes from 'prop-types';

import ApplicationCardMenu from './application_card_menu';

const CardTitle = (props) => {
	const {
		application,
	} = props;
	return (
		<Grid className="application-badge-wrapper">
			<Row>
				{application.decision.decision_warning && (
					<Badge color="upgrade">{application.decision.decision_warning}</Badge>
				)}
			</Row>
		</Grid>
	);
};

const SubmittedFragment = () => (
	<div className="d-flex justify-content-center sma-application-card-submitted mt-auto mb-auto">
		<div className="align-self-center">
			<div className="sma-submitted">
				<i className="nc-icon-mini ui-1_check-circle-08" aria-hidden="true" />
			</div>
		</div>
		<div className="text-left pl-2 sma-submitted-text">
			<h6 className="mb-0">{gettext('Submitted')}</h6>
		</div>
	</div>
);

const AwardedFragment = (props) => {
	const {
		application,
	} = props;
	const awardedValue = application.decision._awarded_value;
	return (
		<div className="d-flex justify-content-center sma-application-card-awarded mt-auto mb-auto">
			<div className="align-self-center">
				<div className="sma-awarded">
					<i className="nc-icon-mini sport_trophy" aria-hidden="true" />
				</div>
			</div>
			<div className="text-left pl-2 sma-awarded-text">
				<h6 className="mb-0">{gettext('Awarded')}</h6>
				<p className="mb-0 sma-shorten-to-one-line">{awardedValue}</p>
			</div>
		</div>
	);
};

const DeclinedFragment = () => (
	<div className="d-flex justify-content-center sma-application-card-declined mt-auto mb-auto">
		<div className="align-self-center">
			<div className="sma-declined">
				<i className="nc-icon-mini ui-1_circle-remove" aria-hidden="true" />
			</div>
		</div>
		<div className="text-left pl-2 sma-declined-text">
			<h6 className="mb-0">{gettext('Declined')}</h6>
		</div>
	</div>
);

const ApplicantDeclinedFragment = () => (
	<div className="d-flex justify-content-center sma-application-card-declined mt-auto mb-auto">
		<div className="align-self-center">
			<div className="sma-declined">
				<i className="nc-icon-mini ui-1_circle-remove" aria-hidden="true" />
			</div>
		</div>
		<div className="text-left pl-2 sma-declined-text">
			<h6 className="mb-0">{gettext('You have declined this award')}</h6>
		</div>
	</div>
);

const ProgressFragment = (props) => {
	const {
		application,
	} = props;
	const {
		progress,
	} = application;
	return (
		<div className="application-card-progress">
			<div className="text-muted text-center wds-m-b-1">{progress.msg}</div>
			<div className="progress sma-application-card-progress">
				<div
					className="progress-bar"
					role="progressbar"
					aria-valuenow={progress.pct}
					aria-valuemin="0"
					aria-valuemax="100"
					style={{ width: `${progress.pct}%` }}
				/>
			</div>
		</div>
	);
};

export default class ApplicationList extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			applications: props.applications,
		};
	}

	render() {
		const {
			applications,
		} = this.state;

		return (
			<Grid className="wds-p-1 application-list">
				<Row>
					{ applications.map((application) => {
						const menuOptions = [
							{
								action: 'download',
								label: gettext('Download'),
							}, {
								action: 'preview',
								label: gettext('Preview'),
							},
						];
						if (application.can_delete) {
							menuOptions.push({
								action: 'delete',
								label: gettext('Delete'),
							});
						}

						let primaryButtonText;
						let primaryButtonColor = 'primary';
						if (application.progress.show_start === true) {
							primaryButtonText = gettext('Start');
						} else if (application.progress.show_continue === true) {
							primaryButtonText = gettext('Continue');
						} else {
							primaryButtonText = gettext('View');
							primaryButtonColor = 'muted';
						}
						const membersText = interpolate(
							ngettext('%s member', '%s members', application.collaborator_count),
							[application.collaborator_count],
						);
						return (
							<Col lg={4} md={6} sm={12} xs={12} className="wds-m-b-3 application-card" key={application.id}>
								<Card
									title={<CardTitle application={application} />}
									addOn={<ApplicationCardMenu application={application} items={menuOptions} />}
								>
									<Typography className="text-muted sma-automation-application-program-name" component="a" href={application.award.listing_url}>{application.award.name}</Typography>
									<Typography>
										<Typography className="application-card-title sma-shorten-to-one-line">
											{application.is_locked && (
												<Typography component="span">
													<i className="nc-icon-mini ui-1_lock" aria-hidden="true" />
													<span className="sr-only">{gettext('Application is locked')}</span>
												</Typography>
											)}
											<b>{application.title}</b>
											{application.collaborator_count > 0 && (
												<i className="nc-icon-mini users_multiple-19 ml-2" data-toggle="tooltip" title={membersText} />
											)}
										</Typography>
										<Typography className="application-id">
											{application.reference_id && application.reference_id !== application.title && (
												application.reference_id
											)}
										</Typography>
									</Typography>
									{application.organization_info.name && (
										<Typography className="application-card-title sma-shorten-to-one-line">
											<small className="text-muted d-block">
												<i className="nc-icon-mini business_building" />
												<Typography component="span" className="wds-m-l-2">{application.organization_info.name}</Typography>
											</small>
										</Typography>
									)}
									<Typography className="application-card-deadline sma-shorten-to-one-line text-muted">
										{application.deadline && (
											<Typography>
												<span className="sma-deadline-text">{gettext('Deadline: ')}</span>
												{application.deadline}
											</Typography>
										)}
									</Typography>
									<hr className="wds-m-t-3 wds-m-b-1" />
									<div className="application-card-info wds-m-b-2">
										<div className="application-card-info-top">
											{application.status && (
												<div>
													<Typography className="sma-shorten-to-one-line">
														<Typography component="span" className="status-label">
															{gettext('Status: ')}
														</Typography>
														<Typography component="span">{application.status}</Typography>
													</Typography>
													<hr className="wds-m-t-1 wds-m-b-3" />
												</div>
											)}
										</div>
										<div className="application-card-info-middle d-flex flex-column justify-content-center">
											{application.decision.awarded && !application.decision.applicant_declined && (
												<AwardedFragment application={application} />
											)}
											{application.decision.declined && !application.decision.applicant_declined && (
												<DeclinedFragment />
											)}
											{application.decision.applicant_declined && (
												<ApplicantDeclinedFragment />
											)}
											{application.is_submitted && !application.decision.decision_date && (
												<SubmittedFragment />
											)}
										</div>
										<div className="application-card-info-bottom d-flex flex-column justify-content-end">
											{application.progress.show_progress && (
												<ProgressFragment application={application} />
											)}
										</div>
									</div>
									<Button
										stretched
										color={primaryButtonColor}
										className="application-button"
										href={application.url}
									>
										{primaryButtonText}
									</Button>
									<div className="wds-flex wds-m-t-3 wds-flex--x-center text-muted">
										<div className="sma-shorten-to-one-line">
											{application.submitted_date && (
												interpolate(gettext('Submitted on: %(submittedDate)s'), {
													submittedDate: application.submitted_date,
												}, true)
											)}
											{!application.submitted_date && (
												interpolate(gettext('Last edited: %(editDate)s'), {
													editDate: application.last_edited,
												}, true)
											)}
										</div>
									</div>
								</Card>
							</Col>
						);
					})}
				</Row>
			</Grid>
		);
	}
}

ApplicationList.propTypes = {
	applications: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.number.isRequired,
		title: PropTypes.string.isRequired,
		can_delete: PropTypes.bool.isRequired,
		is_submitted: PropTypes.bool.isRequired,
		submitted_date: PropTypes.string.is_required,
		last_edited: PropTypes.string.is_required,
	})).isRequired,
};

CardTitle.propTypes = {
	application: PropTypes.shape({
		id: PropTypes.number.isRequired,
	}).isRequired,
};

AwardedFragment.propTypes = {
	application: PropTypes.shape({
		id: PropTypes.number.isRequired,
	}).isRequired,
};

DeclinedFragment.propTypes = {
};

ApplicantDeclinedFragment.propTypes = {
};

ProgressFragment.propTypes = {
	application: PropTypes.shape({
		id: PropTypes.number.isRequired,
	}).isRequired,
};



// WEBPACK FOOTER //
// ../apps/chide/products/smapply/static/sma.applicant/dashboard/application_list.jsx